import { ApiError } from './error.es.js';
export { ApiError } from './error.es.js';
import { normalizeSlashUrl, fetchWithTimeout } from './helpers.es.js';
export { fetchWithTimeout, normalizeSlashUrl } from './helpers.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULT_ERROR_MESSAGE = "\u0110\xE3 c\xF3 l\u1ED7i x\u1EA3y ra, vui l\xF2ng th\u1EED l\u1EA1i sau!";
class Api {
  constructor(url, getError, defaultConfig = {}) {
    this.baseURL = url;
    this.requestInterceptors = [];
    this.responseInterceptors = [];
    this.getError = getError;
    this.defaultConfig = defaultConfig;
  }
  _parseJson(response) {
    return response.text().then((text) => text ? JSON.parse(text) : null);
  }
  addInterceptor(interceptFn) {
    this.requestInterceptors.push(interceptFn);
  }
  addResponseInterceptor(interceptFn) {
    this.responseInterceptors.push(interceptFn);
  }
  appendParamsToURL(url, params, flattenArray = false) {
    if (params) {
      const paramsArr = [];
      for (const k of Object.keys(params)) {
        if (params[k] !== null && params[k] !== void 0) {
          const paramK = params[k];
          if (Array.isArray(paramK) && flattenArray) {
            const flattenArrayString = paramK.map((element) => `${k}=${encodeURIComponent(element)}`).join("&");
            paramsArr.push(flattenArrayString);
          } else {
            paramsArr.push(`${k}=${encodeURIComponent(params[k])}`);
          }
        }
      }
      if (paramsArr.length > 0)
        url = `${url}?${paramsArr.join("&")}`;
    }
    return url;
  }
  async request(path, body, method, config = {}, flattenArray = false) {
    var _a, _b;
    const {
      headers: configHeaders,
      params: configParams,
      timeout: configTimeout
    } = config;
    let headers = __spreadValues(__spreadValues({}, this.defaultConfig.headers), configHeaders);
    const url = this.appendParamsToURL(path, configParams || {}, flattenArray);
    let serializedBody = null;
    if (body) {
      if (typeof body !== "string") {
        if ("append" in body) ; else {
          serializedBody = JSON.stringify(body);
          headers = __spreadValues({
            "Content-Type": "application/json"
          }, headers);
        }
      } else {
        serializedBody = body;
      }
    }
    const fetchUrl = url.startsWith("http") ? url : normalizeSlashUrl(this.baseURL, url);
    const requestObj = __spreadProps(__spreadValues({}, this.defaultConfig), {
      method,
      headers: new Headers(headers),
      body: serializedBody
    });
    this.requestInterceptors.forEach((fn) => fn(requestObj));
    try {
      const res = await fetchWithTimeout(fetchUrl, requestObj, configTimeout);
      const respHeaders = {};
      if (res.status >= 400) {
        try {
          const resp = await res.json();
          res.headers.forEach((val, key) => respHeaders[key] = val);
          const responseObj2 = __spreadValues({
            code: res.status,
            message: res.statusText,
            data: null,
            headers: respHeaders
          }, resp);
          this.responseInterceptors.forEach((fn) => fn(__spreadProps(__spreadValues({}, requestObj), { url: fetchUrl }), responseObj2));
          const error = ((_a = this.getError) == null ? void 0 : _a.call(this, resp)) || new ApiError(`(${fetchUrl}) ${DEFAULT_ERROR_MESSAGE}`, res.status, responseObj2);
          return Promise.reject(error);
        } catch (e) {
          res.headers.forEach((val, key) => respHeaders[key] = val);
          const failedRes = {
            code: res.status,
            message: res.statusText,
            data: null,
            headers: respHeaders
          };
          this.responseInterceptors.forEach((fn) => fn(__spreadProps(__spreadValues({}, requestObj), { url: fetchUrl }), failedRes));
          const error = ((_b = this.getError) == null ? void 0 : _b.call(this, failedRes)) || new ApiError(`(${fetchUrl}) ${DEFAULT_ERROR_MESSAGE}`, res.status, failedRes);
          return Promise.reject(error);
        }
      }
      const parsedData = await this._parseJson(res);
      res.headers.forEach((val, key) => respHeaders[key] = val);
      const responseObj = {
        code: res.status,
        data: parsedData,
        headers: respHeaders
      };
      this.responseInterceptors.forEach((fn) => fn(__spreadProps(__spreadValues({}, requestObj), { url: fetchUrl }), responseObj));
      return responseObj;
    } catch (e) {
      throw e;
    }
  }
  async get(url, config = {}, flattenArray = false) {
    return await this.request(url, null, "GET", config, flattenArray);
  }
  async post(url, body, config = {}) {
    return await this.request(url, body, "POST", config);
  }
  async patch(url, body, config = {}) {
    return await this.request(url, body, "PATCH", config);
  }
  async put(url, body, config = {}) {
    return await this.request(url, body, "PUT", config);
  }
  async delete(url, body = null, config = {}) {
    return await this.request(url, body, "DELETE", config);
  }
}

export { Api };
